import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  declare inputTargets: HTMLInputElement[]

  reset (): void {
    this.element.classList.remove('is-invalid')
    this.element.classList.add('was-invalid')

    this.inputTargets.forEach(input => {
      input.classList.remove(
        'ring-2',
        'ring-stm-error-solid',
        'focus:ring-stm-error-solid',
        'focus-visible:ring-stm-error-solid'
      )

      input.classList.add(
        'border-default'
      )
    })
  }
}
